import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";

import EditDocument from "./Edit";
import Search from "./Search";
import StoreVisits from "./DocumentStorage";
import Pagination from "../../../common/data/Pagination";
import Flatpickr from "react-flatpickr";
import DocumentServices from "../../../services/COOPServices/DocumentServices";
import ViewDocuments from "./ViewDocument";
import toast from "react-hot-toast";
import DeleteModal from "./DeleteDocument";

const Document = () => {
  // State for controlling the modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  // State for storing the selected document for editing
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [viewDocument, setViewDocument] = useState(null);
  const [data, setData] = useState([]);
  const [docId, setDocId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [fileType, setFileType] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Function to toggle the modal
  const toggleModal = (id) => {
    console.log("id : ", id);
    setSelectedDocument(id);
    setModalOpen(!modalOpen);
  };
  const toggleViewModal = (document) => {
    setViewDocument(document);
    setModalOpen1(!modalOpen1);
  };
  const toggleDelete = () => {
    setIsDeleteOpen(!isDeleteOpen);
  };

  const fetchData = async () => {
    try {
      const fetchedData = await DocumentServices.get();

      setData(fetchedData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  console.log("new fetched data: ", data);

  useEffect(() => {
    applyFilters();
  }, [data, searchQuery, fileType, dateRange]);

  const applyFilters = () => {
    let filtered = [...data];
    // console.log("filtered", filtered);

    // Apply search filter
    if (searchQuery !== "") {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply file type filter
    if (fileType) {
      filtered = filtered.filter((item) => item.categoryId === fileType?.value);
    }

    // Apply date range filter
    if (dateRange.length === 2) {
      const [startDate, endDate] = dateRange;
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.createdDate.split("T")[0]);
        return itemDate >= startDate && itemDate <= endDate;
      });
    }

    setFilteredData(filtered);
  };

  const id = (id) => {
    setDocId(id);
  };
  const handleDelete = async (id) => {
    try {
      // window.confirm("Do you really want to delete this Documents List?");
      // const temp = data.filter((item) => item.id !== id);
      // setData(temp);
      const response = await DocumentServices.delete(id);
      toast.success("Document Removed Successfully!");
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const formattedDate = (date) => {
    const createdDate = date;
    const formattedDate = createdDate
      ? createdDate.split("T")[0]
      : "Date not available";
    return formattedDate;
  };

  return (
    <Container fluid>
      <div className="">
        <div className="page-content">
          {/* Search component */}
          <Search
            data={data}
            setData={setData}
            fetchData={fetchData}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            dateRange={dateRange}
            setDateRange={setDateRange}
            fileType={fileType}
            setFileType={setFileType}
          />

          {/* Document cards displayed in a row */}
          <Row className="justify-content-start">
            {/* StoreVisits component */}
            <Col lg={2}>
              <StoreVisits />
            </Col>

            {/* Mapping through the current data and rendering document cards */}
            {filteredData.map((data) => (
              <Col lg={2} key={data.id}>
                <Card
                  style={{
                    maxHeight: "340px",
                    minHeight: "340px",
                    overflow: "hidden",
                  }}
                >
                  <CardBody
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <Row className="justify-content-between">
                        <Col lg={6} xs={6}>
                          {" "}
                          <Button
                            type="button"
                            className="btn btn-sm btn-soft-secondary "
                          >
                            <h6>
                              {" "}
                              <i className="ri-chat-upload-fill align-middle"></i>
                            </h6>
                          </Button>
                        </Col>
                        <Col lg={6} xs={6}>
                          <Row
                            className="justify-content-end p-2"
                            style={{ marginRight: 1 }}
                          >
                            <Col lg={3} xs={3}>
                              <Button
                                title="Edit"
                                type="button"
                                style={{ height: "22px", width: "22px" }}
                                className="btn btn-sm btn-soft-secondary d-flex align-items-center justify-content-center"
                                onClick={() => {
                                  toggleModal(data.id);
                                }}
                              >
                                <i className="ri-edit-line align-middle py-1"></i>
                              </Button>
                            </Col>
                            <Col lg={3} xs={3}>
                              <Button
                                title="Delete"
                                type="button"
                                className="btn btn-sm btn-soft-danger d-flex align-items-center justify-content-center"
                                style={{ height: "22px", width: "22px" }}
                                onClick={() => {
                                  id(data.id);
                                  toggleDelete();
                                }}
                              >
                                <i className="ri-delete-bin-2-line"></i>
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <div className="d-flex align-items-center mb-1">
                        <div className="flex-grow-1">
                          <span
                            style={{ fontSize: "12px" }}
                            className="text-muted "
                          >
                            {data?.title}
                          </span>
                          <p className="my-2 mb-0 fs-12 mb-1">
                            <i class="bx bx-time text-primary "></i>
                            {formattedDate(data?.createdDate)}
                            {/* {data?.createdDate.split("T")[0]} */}
                            {}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          maxHeight: "170px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <div className="py-1 text-muted">
                          {data.description}
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-grid"
                      style={{
                        position: "relative",
                        bottom: "12px",
                        // left: "50%",
                        // transform: "translateX(-50%)",
                        textAlign: "center",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-sm btn-soft-primary"
                        onClick={() => toggleViewModal(data.id)}
                      >
                        View Details
                      </button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          {/* EditDocument component */}
          <EditDocument
            // onClick={handleEdit}
            isOpen={modalOpen}
            toggle={toggleModal}
            selectedDocument={selectedDocument}
            documentId={selectedDocument}
            fetchData={fetchData}
          />

          <ViewDocuments
            isOpen={modalOpen1}
            toggle={toggleViewModal}
            viewDocument={viewDocument}
            documentId={viewDocument}
          />

          <DeleteModal
            deleteTerm={"Document"}
            handleDelete={handleDelete}
            isOpen={isDeleteOpen}
            toggle={toggleDelete}
            id={docId}
          />
        </div>
      </div>
    </Container>
  );
};

export default Document;
